import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { RootState } from "../../../store";
import { BASE_URL, CONTACT_DETAILS_URL, POD_URL } from "../../../Routes/urls";
import Modal, { ModalBody, ModalFooter } from "../../../components/Modal/Modal";
import classes from "./SelectMember.module.css";
import PrimaryButton from "../../../components/Buttons/PrimaryButton";
import Select from "../../../components/Inputs/Select";
import { PatientDetails } from "../../../ts/models/Patient";
import { getPatientFullName } from "../../../utils";

type Props = {
  onClose: () => void;
  data: PatientDetails[];
  eventId?: string;
};

const SelectMember: React.FC<Props> = ({ onClose, data, eventId }) => {
  const { podId } = useParams();
  const navigate = useNavigate();
  const resourceName = useSelector(
    (state: RootState) => state.pod.resourceName
  );
  const [options, setOptions] = useState<PatientDetails[]>([]);

  useEffect(() => {
    if (data?.length)
      setOptions(data.map((e) => ({ ...e, fullName: getPatientFullName(e) })));
  }, [data]);

  const [selected, setSelected] = useState(data[0].id);

  const proceedHandler = async () => {
    if (selected) {
      const patientDetails = data.find((detail) => detail.id === selected);
      if (patientDetails) {
        localStorage.setItem("patientData", JSON.stringify(patientDetails));
        localStorage.setItem("isPatientPortalData", "true");
        navigate(
          `${BASE_URL}/${resourceName}/${POD_URL}/${podId}/event/${eventId}/${CONTACT_DETAILS_URL}`
        );
      }
    }
  };

  return (
    <Modal
      className={classes.modalContainer}
      title={<div className={classes.heading}>Select Member Profile</div>}
      onClose={onClose}>
      <>
        <ModalBody>
          <div className={classes.main}>
            <Select
              className={classes.dropDown}
              selectClass={classes.dropDownSelect}
              label={"Select Member"}
              htmlFor='member'
              options={options}
              value={selected || ""}
              nameExtractor={"fullName"}
              valueExtractor={"id"}
              onChange={(e) => setSelected(e.target.value)}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className={classes.proceedBtnContainer}>
            <PrimaryButton
              name='PROCEED'
              onClick={proceedHandler}
              className={classes.proceedBtn}
              disabled={!selected}
            />
          </div>
        </ModalFooter>
      </>
    </Modal>
  );
};

export default SelectMember;
